import React, { useState } from "react";
import faqs from './FaqContent.json'


const Faqs = () => {


  const [viewAnswer, setViewAnswer] = useState(null)

  const faqData = faqs;
  
  
  return (
    <div>
      <div className="faqs" id="faqs">
        <div className="faqs-main">
          <div className="faqs-label">Frequently Asked Questions</div>
          <div className="faqs-heading">
            Solutions for an every repair problem
          </div>
          <div className="faqs-content">


{
  faqData&&faqData.map( (e, i) => (

          <div className="faqs-content-col">

              <div className={viewAnswer=== i? "faqs-content-question-active faqs-content-question" : "faqs-content-question"}>
                {e.question}
{
  viewAnswer === i ?
  <i class="fa-solid fa-minus" onClick={ () => setViewAnswer("") }></i>
  :
  <i class="fa-solid fa-plus" onClick={ () => setViewAnswer(i) }></i>
}
</div>
                
{
  viewAnswer === i ?
  <div className="faqs-content-answer">{e.answer}</div>
  :
  ""
}
                




            </div>

  ) )
}
            
            

            {/* <div className="faqs-content-col">
              <div className="faqs-content-question faqs-content-question-active">
                Does Onsitego offer AC repairing services in Delhi?
                <i class="fa-solid fa-plus"></i>
              </div>
              <div className="faqs-content-answer">
                Yes, Onsitego offers window and split AC services in Delhi. You
                can book services such as AC gas filling, AC installation and
                annual AC maintenance online. If you're facing specific problems
                like lack of cooling, you can schedule an AC repairing service.
                The service begins at ₹399. It does not, however, include the
                cost of any necessary spare parts.
              </div>
            </div>

            <div className="faqs-content-col">
              <div className="faqs-content-question">
                Does Onsitego offer AC repairing services in Delhi?
                <i class="fa-solid fa-minus"></i>
              </div>
            </div> */}

          

         

          </div>


          <div className="cta-button">
              <a href="#book-now">Book Service Now</a>
            </div>
          
          
          
        </div>
      </div>
    </div>
  );
};

export default Faqs;
